import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { WorkSummaryPage } from '@/features/dashboards/pages/WorkSummaryPage';
import { dcrWorkSummarySearchSchema } from '@/features/dashboards/types/dashboard.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/dashboards/dcr/$userId')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: dcrWorkSummarySearchSchema,
  component: function DcrWorkSummaryRoute() {
    const { userId } = Route.useParams();
    const { dcrTypeId, ...listSearch } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <ErrorBoundary moduleName="Work Summary">
        <Suspense fallback={<PageLoader />}>
          <WorkSummaryPage
            userId={userId}
            period={{ dateFrom: listSearch.dateFrom, dateTo: listSearch.dateTo }}
            dcrTypeId={dcrTypeId}
            viewedRowList="dcrDashboardZms"
            onNoHistory={() => void navigate({ to: '/dashboards/dcr', search: listSearch })}
          />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
